// index.tsx
import React from "react";
import mitt from "mitt";
var BusContext = React.createContext(null);
function useBus() {
  const bus = React.useContext(BusContext);
  if (!bus) throw new Error("useBus: missing context");
  return bus;
}
function useListener(name, listener) {
  const bus = useBus();
  React.useEffect(() => {
    bus.on(name, listener);
    return () => {
      bus.off(name, listener);
    };
  }, [bus, name, listener]);
}
function Provider({ children }) {
  const [bus] = React.useState(() => mitt());
  return /* @__PURE__ */ React.createElement(BusContext.Provider, { value: bus }, children);
}
export {
  Provider,
  useBus,
  useListener
};
